
export default {
  props: {
    reviews: {
      type: Object,
      default: null,
    },
  },
  computed: {
    calculatedScore() {
      return (this.reviews.summary.score / 10).toFixed(1)
    },
    truncCategories() {
      const categoriesCount = 4 + this.isMobile * 2
      return this.reviews.category_list.length > categoriesCount
        ? this.reviews.category_list.slice(0, categoriesCount)
        : this.reviews.category_list
    },
  },
}
